<template>
    <div :class="open ? 'open' : 'closed'" class="accordion">
        <div class="accordion-header">
            <button @click="toggleAccordion" @keydown.esc="open = false" :aria-expanded="open ? 'true' : 'false'" :aria-controls="bodyID" :id="headingID"
                    class="accordion-title"
            >
                <slot name="accordion-header"></slot>
            </button>
        </div>

        <div v-show-slide="open" :aria-labelledby="headingID" :id="bodyID" class="accordion-body">
            <div class="accordion-content">
                <slot name="accordion-content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import VShowSlide from 'v-show-slide'

Vue.use(VShowSlide)

export default {
    name: "Accordion",

    data() {
        return {
            open: false
        }
    },

    computed: {
        headingID() {
            return this.randomID();
        },

        bodyID() {
            return this.randomID();
        }
    },

    methods: {
        toggleAccordion() {
            this.open = !this.open
        },

        randomID() {
            return Math.random().toString(36).substring(4);
        }
    }
}
</script>

